import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-afrotech-connect',
  templateUrl: './afrotech-connect.component.html',
  styleUrls: ['./afrotech-connect.component.scss']
})
export class AfroTechConnectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
